import { COLOR_KEYS } from '../../constants';
import { createBuilderModule } from '../../builder';
import { DEFAULT_VALUES } from './fixtures';
import { Heading, MAX_WIDTH_MAP, SIZE_MAP, SPACING_MAP } from './Heading';

export default createBuilderModule(Heading, {
  name: 'Heading',
  image: 'https://cdn.zappy.app/8bea639e04905dfa561777218501d1c4.svg',
  inputs: [
    {
      name: 'text',
      type: 'string',
      required: true,
      defaultValue: DEFAULT_VALUES.text,
    },
    {
      name: 'tag',
      type: 'string',
      enum: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
      required: true,
      defaultValue: DEFAULT_VALUES.tag,
    },
    {
      name: 'color',
      type: 'string',
      enum: [COLOR_KEYS.earth, COLOR_KEYS.neutral800],
      required: true,
      defaultValue: DEFAULT_VALUES.color,
    },
    {
      name: 'size',
      type: 'string',
      enum: Object.keys(SIZE_MAP),
      required: true,
      defaultValue: DEFAULT_VALUES.size,
    },
    {
      name: 'spacing',
      type: 'string',
      enum: Object.keys(SPACING_MAP),
      required: true,
      defaultValue: DEFAULT_VALUES.spacing,
    },
    {
      name: 'maxWidth',
      type: 'string',
      enum: Object.keys(MAX_WIDTH_MAP),
      required: true,
      defaultValue: DEFAULT_VALUES.maxWidth,
    },
    {
      name: 'isCentered',
      type: 'boolean',
      required: true,
      defaultValue: DEFAULT_VALUES.isCentered,
    },
    {
      name: 'backgroundColor',
      type: 'string',
      enum: [
        COLOR_KEYS.blue10,
        COLOR_KEYS.cream,
        COLOR_KEYS.neutral100,
        COLOR_KEYS.neutral200,
      ],
      required: true,
      defaultValue: DEFAULT_VALUES.backgroundColor,
    },
  ],
});
